import { useEffect, useMemo, useState } from "react";
import { Dialog, DialogContent, Typography, Box, Button } from "@mui/material";
import { motion, AnimatePresence } from "framer-motion";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Link } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../../config";

const steps = [
  "Install Server offline Exam mode",
  "dowload the Bonjuor App from the link below to continue the exams",
  "Click continue to download server offline file",
  "Open the file to begin your test",
];

const MotionBox = motion(Box);
const MotionButton = motion(Button);

export function ServerDialog({ open, setOpen, handleDownload }) {
  const [loading, setLoading] = useState(false);
  const [hoveredStep, setHoveredStep] = useState(null);
  const [desktopLinks, setDesktopLinks] = useState({ win: null, linux: null })

  console.log(setLoading)


   const downloadLink = useMemo(() => {
     const ua = navigator.userAgent;
     if (/Win/i.test(ua)) return desktopLinks.win;
     if (/Linux/i.test(ua)) return desktopLinks.linux;
     return null;
   }, [desktopLinks]);

   useEffect(() => {
     axios
       .get(`${API_URL}/desktop-app/`)
       .then((r) =>
         setDesktopLinks({
           win: r.data.DESKTOP_APP_WIN,
           linux: r.data.DESKTOP_APP_LINUX,
         })
       )
       .catch(console.error);
   }, []);
  
  console.log(desktopLinks)

 

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        component: motion.div,
        initial: { opacity: 0, scale: 0.92, y: 20 },
        animate: {
          opacity: 1,
          scale: 1,
          y: 0,
          transition: { type: "spring", stiffness: 300, damping: 28 },
        },
        exit: { opacity: 0, scale: 0.94, y: 10 },
        sx: { borderRadius: 4, overflow: "hidden", p: 0 },
      }}
    >
      {/* Progress bar */}
      <Box
        sx={{
          height: 3,
          bgcolor: "grey.100",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <MotionBox
          sx={{
            height: "100%",
            background: "linear-gradient(90deg,#22c55e,#86efac)",
            position: "absolute",
            top: 0,
            left: 0,
          }}
          initial={{ width: 0 }}
          animate={{
            width: "100%",
            transition: { duration: 1.5, ease: "easeOut", delay: 0.3 },
          }}
        />
      </Box>

      <DialogContent sx={{ pt: 4, pb: 0, px: 3.5 }}>
        {/* Icon */}
        <MotionBox
          initial={{ scale: 0, rotate: -15 }}
          animate={{
            scale: 1,
            rotate: 0,
            transition: {
              type: "spring",
              stiffness: 350,
              damping: 22,
              delay: 0.1,
            },
          }}
          sx={{
            width: 64,
            height: 64,
            borderRadius: "50%",
            bgcolor: "#f0fdf4",
            border: "1.5px solid #bbf7d0",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mx: "auto",
            mb: 2.5,
          }}
        >
          <CheckCircleOutlineIcon sx={{ color: "#16a34a", fontSize: 30 }} />
        </MotionBox>

        <Typography
          variant="h6"
          sx={{
            textAlign: "center",
            fontWeight: 600,
            letterSpacing: "-0.3px",
            mb: 0.5,
          }}
        >
          Before You Start
        </Typography>
        <Typography
          variant="caption"
          display="block"
          sx={{ textAlign: "center", color: "text.secondary", mb: 3 }}
        >
          Complete these steps to launch your exam
        </Typography>

        {/* Steps */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, mb: 3 }}>
          {steps.map((label, i) => (
            <MotionBox
              key={i}
              initial={{ opacity: 0, x: -12 }}
              animate={{
                opacity: 1,
                x: 0,
                transition: {
                  delay: 0.12 + i * 0.07,
                  type: "spring",
                  stiffness: 260,
                  damping: 24,
                },
              }}
              whileHover={{ x: 4 }}
              onHoverStart={() => setHoveredStep(i)}
              onHoverEnd={() => setHoveredStep(null)}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                p: "12px 14px",
                borderRadius: 2.5,
                bgcolor: hoveredStep === i ? "#f0f9ff" : "#f8fafc",
                border: "1px solid",
                borderColor: hoveredStep === i ? "#bae6fd" : "#f1f5f9",
                cursor: "default",
                transition: "background 0.2s, border-color 0.2s",
              }}
            >
              <Box
                sx={{
                  width: 30,
                  height: 30,
                  borderRadius: "50%",
                  bgcolor: "#0ea5e9",
                  color: "#fff",
                  fontWeight: 600,
                  fontSize: 13,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                {i + 1}
              </Box>
              <Typography
                sx={{
                  fontSize: 13.5,
                  fontWeight: 500,
                  color: "text.primary",
                  flex: 1,
                }}
              >
                {label}
              </Typography>
              <motion.span
                animate={{
                  opacity: hoveredStep === i ? 1 : 0.25,
                  x: hoveredStep === i ? 2 : 0,
                }}
                style={{ color: "#94a3b8", fontSize: 14 }}
              >
                →
              </motion.span>
            </MotionBox>
          ))}
          <Link
            to="https://support.apple.com/en-us/106380?utm_source=chatgpt.com"
            target="blank"
          >
            Download link for Bonjour App here
          </Link>
        </Box>
      </DialogContent>

      <Box sx={{ height: "1px", bgcolor: "grey.100", mx: 3.5 }} />

      <Box sx={{ display: "flex", gap: 1.25, p: 2.5, pt: 2 }}>
        <MotionButton
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.97 }}
          variant="outlined"
          onClick={() => setOpen(false)}
          sx={{
            flex: 1,
            borderRadius: 3,
            borderColor: "grey.200",
            color: "text.secondary",
            fontWeight: 500,
            textTransform: "none",
          }}
        >
          Cancel
        </MotionButton>
        <MotionButton
          whileTap={{ scale: 0.97 }}
          variant="contained"
          href={downloadLink}
          target="_blank"
          disabled={loading}
          endIcon={
            !loading && (
              <ArrowForwardIcon sx={{ fontSize: "15px !important" }} />
            )
          }
          sx={{
            flex: 1.6,
            borderRadius: 3,
            textTransform: "none",
            fontWeight: 600,
            background: "linear-gradient(135deg,#22c55e,#16a34a)",
            boxShadow: "0 4px 14px rgba(34,197,94,0.35)",
            "&:hover": {
              boxShadow: "0 6px 20px rgba(34,197,94,0.45)",
              background: "linear-gradient(135deg,#22c55e,#16a34a)",
            },
          }}
        >
          <AnimatePresence mode="wait">
            <motion.span
              key={loading ? "l" : "c"}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.15 }}
            >
              {loading ? "Downloading…" : "Continue"}
            </motion.span>
          </AnimatePresence>
        </MotionButton>
      </Box>
    </Dialog>
  );
}
